import React from "react";
import { api } from "../lib/api";
import { normalizeDashboardEvent } from "../lib/dashboardGadgets";
const shell = "rounded-2xl border border-[#ffd166]/25 bg-[#080b14]/70 p-4";
const safeUrl = url => /^https?:\/\//i.test(String(url || "")) ? url : "";

export function lessonResourceUrl(resource) {
    return resource.file_id && /^\/children\/[^/]+\/classes\/[^/]+\/lesson-files\/[a-f0-9]+$/.test(resource.url || "")
        ? `${api.defaults?.baseURL || "/api"}${resource.url}` : safeUrl(resource.url);
}

export function LessonResource({resource}) {
    const url = lessonResourceUrl(resource);
    if (!url) return null;
    let videoUrl = "";
    try {
        const parsed = new URL(url, window.location.origin);
        if (["www.youtube.com", "youtube.com", "youtu.be"].includes(parsed.hostname)) {
            const id = parsed.hostname === "youtu.be" ? parsed.pathname.slice(1) : parsed.searchParams.get("v") || parsed.pathname.split("/").pop();
            if (/^[\w-]+$/.test(id || "")) videoUrl = `https://www.youtube-nocookie.com/embed/${id}`;
        } else if (["vimeo.com", "www.vimeo.com"].includes(parsed.hostname) && /^\/\d+$/.test(parsed.pathname)) videoUrl = `https://player.vimeo.com/video${parsed.pathname}`;
    } catch { /* An ordinary link remains available below. */ }
    return <article className={shell}>
        <h4 className="mb-2 font-semibold text-[#fff3c4]">{resource.title || "Lesson resource"}</h4>
        {resource.kind === "pdf" ? <iframe title={resource.title || "Lesson PDF"} src={url} className="h-[65vh] min-h-[400px] w-full rounded-xl bg-white" />
            : resource.kind === "image" ? <img src={url} alt={resource.title || "Lesson attachment"} className="max-h-[65vh] w-full rounded-xl object-contain" />
            : videoUrl ? <iframe title={resource.title || "Lesson video"} src={videoUrl} className="aspect-video w-full rounded-xl" allow="fullscreen; picture-in-picture" allowFullScreen />
            : resource.kind === "video" ? <video controls src={url} className="max-h-[65vh] w-full rounded-xl" /> : null}
        <a href={url} target="_blank" rel="noopener noreferrer" className="mt-2 inline-block text-sm text-cyan-300 underline">Open {resource.title || "resource"}</a>
    </article>;
}

export function LessonCalendarDetails({event}) {
    if (!event) return null;
    const item = normalizeDashboardEvent(event);
    const breakdown = item.breakdown || [];
    const resources = item.resources || [];
    if (!item.lesson_id && !item.lesson_sections?.length && !item.lesson_assignment_ids) return null;
    return <div className="space-y-3">
        <h4 className="font-display text-xl text-[#ffd166]">Lesson breakdown</h4>
        {breakdown.map((step, index) => <div key={step.event_id || index} className={shell}><p className="font-semibold text-[#fff3c4]">{index + 1}. {step.title}</p>{step.start_time && <p className="text-xs text-[#d8b4fe]">{step.start_time}–{step.end_time}</p>}{step.description && <p className="whitespace-pre-wrap text-sm text-[#b0b8d6]">{step.description}</p>}</div>)}
        {resources.map((resource, index) => <LessonResource key={resource.file_id || index} resource={resource} />)}
    </div>;
}

